import * as types from "../types";

export const getPhysicalRooms = () => ({
  type: types.GET_PHYSICAL_ROOMS,
  request: {
    url: "/physical_rooms",
    method: "GET"
  }
});

export const getPhysicalRoom = ({ id }) => {
  const request = {
    type: types.GET_PHYSICAL_ROOM,
    request: {
      url: `/physical_rooms/${id}`,
      method: "GET",
      params: {}
    }
  };

  return request;
};

export const getPhysicalRoomUsers = ({ roomId, filter, page, perPage }) => {
  const request = {
    type: types.GET_PHYSICAL_ROOM_USERS,
    request: {
      url: `/physical_rooms/${roomId}/users`,
      method: "GET",
      params: { page, per_page: perPage, "q[email_or_profile_full_name_i_cont]": filter }
    }
  };
  return request;
};
